// Public Landing Page Assets API (no auth, no key).
// Endpoint owner: admin.loopai.in / Landing Page Assets dashboard.

const ADMIN_API = "https://admin.loopai.in";

let cachedPromise = null;

export async function getLandingAssets() {
  if (cachedPromise) return cachedPromise;

  cachedPromise = (async () => {
    try {
      const res = await fetch(`${ADMIN_API}/api/v1/public/landing-assets`, {
        method: "GET",
        headers: { Accept: "application/json" },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      return data?.sections || {};
    } catch (err) {
      // Endpoint unavailable -> empty sections, components will use static fallbacks.
      // eslint-disable-next-line no-console
      console.warn("[landingAssets] Failed to fetch:", err?.message || err);
      return {};
    }
  })();

  return cachedPromise;
}

// First active asset of a section (most sections use just one).
export const first = (list) => (list && list[0]) || null;

// Convert a YouTube/Vimeo watch link into an embeddable URL.
export function toEmbedUrl(link = "") {
  const yt = link.match(/(?:youtu\.be\/|v=)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vm = link.match(/vimeo\.com\/(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return link;
}

// Detect uploaded-file URLs (served from GCS).
export const isUploadedFile = (url = "") => url.includes("storage.googleapis.com");

// Flatten brand assets (single carousel OR multiple image assets) into a logo list.
export function flattenBrands(brandAssets = []) {
  return brandAssets.flatMap((b) =>
    b.media_type === "carousel"
      ? (b.items || []).map((it) => ({ url: it.url, caption: it.caption || "" }))
      : [{ url: b.url, caption: b.title || "" }]
  );
}
